import React, { useState, useEffect, useCallback,  useRef } from "react";
import { useSelector } from "react-redux";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import {
     Chart as ChartJS,
     ArcElement,
     CategoryScale,
     LinearScale,
     PointElement,
     LineElement,
     Title,
     Tooltip,
     Legend,
} from "chart.js";
import RGL,{ Responsive, WidthProvider } from "react-grid-layout";
import DoughnutGraph from "./views/DoughnutGraph";
import LineGraph from "./views/LineGraph";
import CarouselGraph from "./views/CarouselGraph";
import ColumnGraph from "./views/ColumnGraph";
import CommunicationsGraph from "./views/CommunicationsGraph";
import { dashboardConstants } from "../../../_redux/_constants/dashboard.constants";
import {
     ContentRightWr,
     MainLeftTitle,
     CreateButton,
} from "../../_uiComponents/WrapperComponents";
import CampaignDonutsGraph from "./views/CampaignDonutsGraph";
import { useDispatch } from "react-redux";
import {
     dashBoardGetCampaignPageViewSummaryRequest,
     dashBoardGetCommsPageViewSummaryRequest,
     dashBoardGetParticipantActivationSummaryRequest,
     dashBoardGetParticipantLoginSummaryRequest,
     dashBoardGetRewardIssuedByCampaignRequest,
     dashBoardGetDashboardSummaryRequest,
     getEmailTrackingSummaryRequest,
     getEmailDispatchSummaryRequest,
     getQ4OilMasterSummaryRequest,
     getWearTearSummaryRequest,
     getAbuDhabiSummaryRequest,
     getDevicedUsedSummaryRequest,
     getAreaListRequest,
     dashBoardGetAreaManagersLeaguesRankSummaryRequest,
} from "../../../_redux/_actions";
import { participantJobRoleIds } from "../../../_redux/_constants";
import UiSelect from "../../_uiComponents/common/form/UiSelectDefault";

import StatisticCarousel from "./views/StatisticCarousel";
import ParticipantActivationSummary from "./views/ParticipantActivationSummary";
import RewardIssuedByCampaign from "./views/RewardIssuedByCampaign";
import UserLoginSummary from "./views/UserLoginSummary";
import EmailTracking from "./views/EmailTracking";
import CampaignPageViewSummary from "./views/CampaignPageViewSummary";
import CommsPageSummary from "./views/CommsPageSummary";
import EmailDespatches from "./views/EmailDespatches";
import DeviceUsed from "./views/DeviceUsed";

const ResponsiveGridLayout = WidthProvider(Responsive);

function DashboardWrapper() {
     const actionDispatch = useDispatch();

     const [userType, setUserType] = useState("0");

     const getApplicationTypeInitialData = (value) => {
          actionDispatch(
               dashBoardGetDashboardSummaryRequest({ applicationId: value }),
          );

          setUserType(value);
     };

     const jobRolesOptions = {
          0: [
               {
                    value: "0",
                    label: "All",
               },

               {
                    value: participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_MANAGER,
                    label: "Participant Service Manager",
               },
               {
                    value: participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_ADVISOR,
                    label: "Participant Service Advisor",
               },
               {
                    value: participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER,
                    label: "Participant Service Area Manager",
               },
               {
                    value: participantJobRoleIds.TLC_PARTICIPANT_CUSTOMER,
                    label: "TLC Participant Customer",
               },
               {
                    value: participantJobRoleIds.TLC_PARTICIPANT_AREA_MANAGER,
                    label: "TLC Participant Area Manager",
               },
          ],

          1: [
               {
                    value: "0",
                    label: "All",
               },

               {
                    value: participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_MANAGER,
                    label: "Participant Service Manager",
               },
               {
                    value: participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_ADVISOR,
                    label: "Participant Service Advisor",
               },
               {
                    value: participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER,
                    label: "Participant Service Area Manager",
               },
          ],
          3: [
               {
                    value: "0",
                    label: "All",
               },

               {
                    value: participantJobRoleIds.TLC_PARTICIPANT_CUSTOMER,
                    label: "TLC Participant Customer",
               },
               {
                    value: participantJobRoleIds.TLC_PARTICIPANT_AREA_MANAGER,
                    label: "TLC Participant Area Manager",
               },
          ],
     };

     const getDashboardSummaryData = () => {
          actionDispatch(
               dashBoardGetDashboardSummaryRequest({ applicationId: userType }),
          );
     };

     const getQ4OilMasterSummary = (
          startDate = null,
          roleId = null,
          applicationId = userType,
     ) => {
          actionDispatch(
               getQ4OilMasterSummaryRequest({
                    roleId,
                    startDate,
                    applicationId,
               }),
          );
     };

     const getWearTearSummary = (
          startDate = null,
          roleId = null,
          applicationId = userType,
     ) => {
          actionDispatch(
               getWearTearSummaryRequest({
                    roleId,
                    startDate,
                    applicationId,
               }),
          );
     };

     const getAbuDhabiSummary = (
          startDate = null,
          endDate = null,
          roleId = null,
          applicationId = userType,
     ) => {
          actionDispatch(
               getAbuDhabiSummaryRequest({
                    roleId,
                    startDate,
                    endDate,
                    applicationId,
               }),
          );
     };

     const getParticipantActivationSummaryData = (
          startDate = null,
          endDate = null,
          areaId = null,
          applicationId = userType,
     ) => {
          actionDispatch(
               dashBoardGetParticipantActivationSummaryRequest({
                    startDate,
                    endDate,
                    areaId,
                    applicationId,
               }),
          );
     };

     const getRewardIssuedByCampaignData = (
          startDate = null,
          endDate = null,
          roleId = null,
          areaId = null,
          applicationId = userType,
     ) => {
          actionDispatch(
               dashBoardGetRewardIssuedByCampaignRequest({
                    roleId,
                    startDate,
                    endDate,
                    areaId,
                    applicationId,
               }),
          );
     };

     const getDevicedUsedSummaryData = (
          startDate = null,
          endDate = null,
          roleId = null,
          areaId = null,
          applicationId = userType,
     ) => {
          actionDispatch(
               getDevicedUsedSummaryRequest({
                    roleId,
                    startDate,
                    endDate,
                    areaId,
                    applicationId,
               }),
          );
     };

     const getUserLoginSummaryData = (
          startDate = null,
          endDate = null,
          roleId = null,
          areaId = null,
          applicationId = userType,
     ) => {
          actionDispatch(
               dashBoardGetParticipantLoginSummaryRequest({
                    roleId,
                    startDate,
                    endDate,
                    areaId,
                    applicationId,
               }),
          );
     };

     const getEmailTrackingSummaryData = (
          startDate = null,
          endDate = null,
          applicationId = userType,
     ) => {
          actionDispatch(
               getEmailTrackingSummaryRequest({
                    startDate,
                    endDate,
                    applicationId,
               }),
          );
     };

     const getCampaignPageViewSummaryData = (
          startDate = null,
          endDate = null,
          roleId = null,
          areaId = null,
          applicationId = userType,
     ) => {
          actionDispatch(
               dashBoardGetCampaignPageViewSummaryRequest({
                    roleId,
                    startDate,
                    endDate,
                    areaId,
                    applicationId,
               }),
          );
     };

     const getCommsPageViewSummaryData = (
          startDate = null,
          endDate = null,
          roleId = null,
          areaId = null,
          applicationId = userType,
     ) => {
          actionDispatch(
               dashBoardGetCommsPageViewSummaryRequest({
                    roleId,
                    startDate,
                    endDate,
                    areaId,
                    applicationId,
               }),
          );
     };

     const getEmailDispatchSummaryData = (
          startDate = null,
          endDate = null,
          applicationId = userType,
     ) => {
          actionDispatch(
               getEmailDispatchSummaryRequest({
                    startDate,
                    endDate,
                    applicationId,
               }),
          );
     };

     const options = [
          { value: "0", label: "All" },
          { value: "1", label: "Equipe" },
          { value: "3", label: "TLC" },
     ];

     const [graphList, setGraphList] = useState([
          // {
          //      id: "1",
          //      type: "carousel",
          //      name: "",
          //      location: { x: 0, y: 0, w: 2, h: 1.5 },
          // },
          // {
          //      id: "2",
          //      type: "column",
          //      name: "Participant Activation Summary",
          //      location: { x: 0, y: 1, w: 1, h: 3.8 },
          // },
          // {
          //      id: "3",
          //      type: "column",
          //      name: "Reward Issued By Campaign",
          //      location: { x: 1, y: 1, w: 1, h: 3.8 },
          // },
          // {
          //      id: "4",
          //      type: "column",
          //      name: "Email Despatches",
          //      location: { x: 0, y: 7, w: 2, h: 3.8 },
          // },
          // {
          //      id: "5",
          //      type: "line",
          //      name: "User Login Summary",
          //      location: { x: 0, y: 2, w: 2, h: 3.8 },
          // },
          // {
          //      id: "6",
          //      type: "line",
          //      name: "Campaign Page View Summary",
          //      location: { x: 0, y: 4, w: 2, h: 3.8 },
          // },
          // {
          //      id: "7",
          //      type: "line",
          //      name: "Comms Page View Summary",
          //      location: { x: 0, y: 5, w: 2, h: 3.8 },
          // },
          // {
          //      id: "8",
          //      type: "line",
          //      name: "Device Used",
          //      location: { x: 0, y: 6, w: 2, h: 3.8 },
          // },
          // {
          //      id: "9",
          //      type: "line",
          //      name: "Email Tracking",
          //      location: { x: 0, y: 3, w: 2, h: 4.5 },
          // },
          // {
          //      id: "10",
          //      type: "donut",
          //      name: "Campaign Carousel",
          //      location: { x: 0, y: 7, w: 2, h: 3.75 },
          // },
     ]);

     // const { graphList } = useSelector((state) => {
     //      return { graphList: state.dashboard.graphList };
     // });
     const gridContainerRef = useRef(null);

     const [layouts, setLayouts] = useState([
          { x: 0, y: 0, w: 1, h: 2.5 },
          { x: 1, y: 0, w: 1, h: 2.5 },
          { x: 0, y: 2, w: 2, h: 2.5 },
          { x: 0, y: 3, w: 2, h: 1.5 },
          { x: 0, y: 4, w: 2, h: 2 },
     ]);

     const [newLayouts, setNewLayouts] = useState([]);
   

     const onLayoutChange = (layout) => {
          setLayouts(layout);
          setNewLayouts(layout.map(({ x, y, i }) => ({ x, y, i })));    
     };

     console.log(newLayouts)

     // useEffect(() => {
     //      const updatedLayout = layouts.map((item1) => {
     //           const item2 = newLayouts.find((item) => item.i === item1.i);
     //           return { ...item1, ...item2 };
     //      });
     //      setLayouts(updatedLayout);
     // }, [newLayouts]);

     useEffect(() => {
          actionDispatch(getAreaListRequest());
     }, []);

     

     const onDragStart = (layout) => {
    
     const handleScroll = (e) => {
       const gridContainer = gridContainerRef.current;
       if (!gridContainer) return;
 
       const buffer = 50;  
       const scrollSpeed = 150;  
 
       const { clientX, clientY } = e;
        
       if (clientY < buffer) {
         document.body.scrollBy(0, -scrollSpeed);
       } else if (clientY > window.innerHeight - buffer) {
         document.body.scrollBy(0, scrollSpeed);
       }
     };
 
     window.addEventListener('mousemove', handleScroll);
 
    
     const cleanup = () => {
       window.removeEventListener('mousemove', handleScroll);
     };
 
     window.addEventListener('mouseup', cleanup, { once: true });
   };


     return (
          <>
               <div className="sb-admin-dashboard-top-wr">
                    <MainLeftTitle title="Dashboard" />
               </div>
               <div className="sba-chart-section-top-search">
                    <UiSelect
                         options={options}
                         value={userType}
                         handleChange={(value) =>
                              getApplicationTypeInitialData(value)
                         }
                    />
               </div>
               <div ref={gridContainerRef} className="grid-container">
               <ResponsiveGridLayout
                    className="layout"
                    draggableCancel=".cancelSelectorName"
                    isResizable={false}
                    // compactType="vertical"
                    // maxRows={4}
                    measureBeforeMount={false}                  
                    isDraggable
                    isRearrangeable
                    onDragStart={onDragStart}
                    // useCSSTransforms={true}
                    draggableHandle=".sba-drag-handle"
                    onLayoutChange={(layout) => onLayoutChange(layout)}
                    breakpoints={{
                         lg: 1300,
                         md: 996,
                         sm: 768,
                         xs: 480,
                         xxs: 0,
                    }}
                    cols={{ lg: 2, md: 2, sm: 2, xs: 1, xxs: 1 }}
               >
                    <div
                         key={11}
                         className="sba-grid-column"
                         data-grid={{ x: 0, y: 0, w: 2, h: 1.5 }}
                    >
                         <StatisticCarousel
                              applicationId={userType}
                              getData={getDashboardSummaryData}
                         />
                    </div>

                    <div
                         key={12}
                         className="sba-grid-column"
                         data-grid={{ x: 0, y: 1, w: 1, h: 3.8 }}
                    >
                         <ParticipantActivationSummary
                              applicationId={userType}
                              getData={getParticipantActivationSummaryData}
                         />
                    </div>

                    <div
                         key={13}
                         className="sba-grid-column"
                         data-grid={{ x: 1, y: 1, w: 1, h: 3.8 }}
                    >
                          {/* <ParticipantActivationSummary
                              applicationId={3}
                              getData={getParticipantActivationSummaryData}
                         /> */}
                         <RewardIssuedByCampaign
                              applicationId={userType}
                              getData={getRewardIssuedByCampaignData}
                              jobRolesOptions={jobRolesOptions[userType]}
                         />
                    </div>

                    <div
                         key={20}
                         className="sba-grid-column"
                         data-grid={{ x: 0, y: 2, w: 2, h: 3.75 }}
                    >
                         <CampaignDonutsGraph
                              applicationId={userType}
                              jobRolesOptions={jobRolesOptions[userType]}
                              getQ4OilMasterSummary={getQ4OilMasterSummary}
                              getWearTearSummary={getWearTearSummary}
                              getAbuDhabiSummary={getAbuDhabiSummary}
                         />
                    </div>

                     <div
                         key={14}
                         className="sba-grid-column"
                         data-grid={{ x: 0, y: 3, w: 2, h: 3.8 }}
                    >
                         <UserLoginSummary
                              applicationId={userType}
                              getData={getUserLoginSummaryData}
                              jobRolesOptions={jobRolesOptions[userType]}
                         />
                    </div>

                    <div
                         key={16}
                         className="sba-grid-column"
                         data-grid={{ x: 0, y: 4, w: 2, h: 3.8 }}
                    >
                         <CampaignPageViewSummary
                              applicationId={userType}
                              getData={getCampaignPageViewSummaryData}
                              jobRolesOptions={jobRolesOptions[userType]}
                         />
                    </div>

                    <div
                         key={17}
                         className="sba-grid-column"
                         data-grid={{ x: 0, y: 5, w: 2, h: 3.8 }}
                    >
                         <CommsPageSummary
                              applicationId={userType}
                              getData={getCommsPageViewSummaryData}
                              jobRolesOptions={jobRolesOptions[userType]}
                         />
                    </div>

                    <div
                         key={18}
                         className="sba-grid-column"
                         data-grid={{ x: 0, y: 6, w: 2, h: 3.8 }}
                    >
                         <EmailDespatches
                              applicationId={userType}
                              getData={getEmailDispatchSummaryData}
                         />
                    </div>

                    <div
                         key={15}
                         className="sba-grid-column"
                         data-grid={{ x: 0, y: 7, w: 2, h: 4.5 }}
                    >
                         <EmailTracking
                              applicationId={userType}
                              getData={getEmailTrackingSummaryData}
                         />
                    </div>

                                    
                    <div
                         key={19}
                         className="sba-grid-column"
                         data-grid={{ x: 0, y: 8, w: 2, h: 3.8 }}
                    >
                         <DeviceUsed
                              applicationId={userType}
                              getData={getDevicedUsedSummaryData}
                              jobRolesOptions={jobRolesOptions[userType]}
                         />
                    </div> 
                
                   
               </ResponsiveGridLayout>
               </div>
          </>
     );
}

export default DashboardWrapper;
